const API_PATH = {
  SAVE_USER: "/policy/prosure/partner/saveUser",
  LOGIN: "/admin-login",
  RESEND_OTP: "/policy/prosure/partner/resendOTP/",
  VERIFY_OTP: "/policy/prosure/partner/authenticateOTP",
  INITIATED_PAYMENT: "/third-party/coversure/payU/initiatePayment",
  PAYMENT_STATUS: "/third-party/coversure/payU/checkTransactionStatus/",
  VERIFICATION: "/policy/prosure/partner/verification"

};

export default API_PATH;
